'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTvAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#72AFC8" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0004 17.3334L11.0576 17.6095L11.3337 16.6667L11.0576 15.7239L12.0004 16L12.9432 15.7239L12.667 16.6667L12.9432 17.6095L12.0004 17.3334ZM16.0004 16L15.0576 16.2762L15.3337 15.3334L15.0576 14.3906L16.0004 14.6667L16.9432 14.3906L16.667 15.3334L16.9432 16.2762L16.0004 16ZM20.0004 16L19.0576 16.2762L19.3337 15.3334L19.0576 14.3906L20.0004 14.6667L20.9432 14.3906L20.667 15.3334L20.9432 16.2762L20.0004 16ZM22.667 13.3334L21.7242 13.6095L22.0004 12.6667L21.7242 11.7239L22.667 12L23.6098 11.7239L23.3337 12.6667L23.6098 13.6095L22.667 13.3334ZM25.3337 10.6667L24.3909 10.9428L24.667 10L24.3909 9.05723L25.3337 9.33337L26.2765 9.05723L26.0004 10L26.2765 10.9428L25.3337 10.6667ZM17.3337 12L16.3909 12.2762L16.667 11.3334L16.3909 10.3906L17.3337 10.6667L18.2765 10.3906L18.0004 11.3334L18.2765 12.2762L17.3337 12ZM20.0004 6.66671L19.0576 6.94285L19.3337 6.00004L19.0576 5.05723L20.0004 5.33337L20.9432 5.05723L20.667 6.00004L20.9432 6.94285L20.0004 6.66671ZM22.667 5.33337L21.7242 5.60951L22.0004 4.66671L21.7242 3.7239L22.667 4.00004L23.6098 3.7239L23.3337 4.66671L23.6098 5.60951L22.667 5.33337ZM25.3337 4.00004L24.3909 4.27618L24.667 3.33337L24.3909 2.39056L25.3337 2.66671L26.2765 2.39056L26.0004 3.33337L26.2765 4.27618L25.3337 4.00004Z",
          fill: "#FFCD2F"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagTvAsset = forwardRef(FlagTvAsset);

export { VpFlagTvAsset as default };
